import { useQueryClient } from "@tanstack/react-query";

import { $api } from "@/shared/api";

import { billingStatusQueryOptions } from "./billingStatusQueryOptions";

// Отключить автоплатёж (`POST /api/billing/autopay/cancel`). Ответ — новый статус Pro:
// автоплатёж «отключается», а когда платёжный сервис подтвердит, придёт `billing.updated`.
export const useCancelAutopay = () => {
  const queryClient = useQueryClient();
  return $api.useMutation("post", "/api/billing/autopay/cancel", {
    onSuccess: (status) => {
      queryClient.setQueryData(billingStatusQueryOptions().queryKey, status);
    },
  });
};
